import React, { createContext, useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged, onIdTokenChanged } from 'firebase/auth';
import { firebase } from './firebaseConfig';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const auth = getAuth(firebase);
        // 1) Gate the UI based on stable auth state
        const unsubAuth = onAuthStateChanged(auth, (firebaseUser) => {
            setUser(firebaseUser || null);
            setLoading(false);
        });
        // 2) Track fresh ID token separately, without toggling user
        const unsubToken = onIdTokenChanged(auth, async (firebaseUser) => {
            if (firebaseUser) {
                try {
                    const fresh = await firebaseUser.getIdToken();
                    setToken(fresh);
                } catch {
                    // leave last good token; UI remains signed-in
                }
            } else {
                setToken(null);
            }
        });
        return () => { unsubAuth(); unsubToken(); };
    }, []);

    return (
        <AuthContext.Provider value={{ user, token, loading }}>
            {children}
        </AuthContext.Provider>
    );
};
